import { Button } from "react-bootstrap";
import { React, useEffect, useState } from "react";
import styled from "styled-components";
import { getFooterByPartnerId } from "../../api/axios";
import { Link, useParams } from "react-router-dom";
import "./footer.css";
import CmsCircularProgress from "../../Components/Common/CircularProgress";
import { showToast } from "../../Utills/toast";
import CustomTable from "../../Components/Common/DataTable/DataTable";
import { getFileNameFromUrl } from "../../Utills/fileNameFromUrl";

// const id = 7;

export default function Footer() {
  const { partnerId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    phoneNo: "",
    mailing_address: "",
    email_address: "",
    paragraph: "",
    faq: "",
    privacy_policy: "",
    facebook: "",
    twitter: "",
    linkedin: "",
    instagram: "",
    pinterest: "",
  });

  const fetchFooter = async () => {
    setIsLoading(true);
    if (!Number(partnerId)) {
      setIsLoading(false);
      return;
    }
    try {
      const res = await getFooterByPartnerId(partnerId);
      const footetdata = res.data.data[0];
      setData((prevData) => {
        return { ...prevData, ...footetdata, index: res.data.data.indexOf(footetdata) };
      });
    } catch (err) {
     showToast({
      type: 'error',
      message: err.response.data.message || 'Failed to fetch footer. Please try again.',
     });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFooter();
  }, []);
  
  const columns = [
    {
      text: "Paragraph",
      width: "280px"
    },
    {
      text: "Mailing Address",
      width: "140px"
    },
    {
      text: "Phone Number",
      width: "140px"
    },
    {
      text: "Email",
      width: "280px"
    },
    {
      text: "FAQ",
      width: "200px"
    },
    {
      text: "Privacy Policy",
      width: "200px"
    },
  ];  
  const rows = [];

  if (data && Object.keys(data).length > 0 && data.index !== -1) {
    rows.push([data.paragraph, data.mailing_address, data.phoneNo, data.email_address, (<div className="overflow-hidden white-space-nowrap text-overflow-ellipsis" style={{maxWidth: "250px", textOverflow: "ellipsis", whiteSpace: "nowrap", wordWrap: "break-word"}}>{getFileNameFromUrl(data.faq)}</div>), (<div className="overflow-hidden white-space-nowrap text-overflow-ellipsis" style={{maxWidth: "250px", textOverflow: "ellipsis", whiteSpace: "nowrap", wordWrap: "break-word"}}>{getFileNameFromUrl(data.privacy_policy)}</div>)]);
  }

  const columnsSocial = [
    {
      text: "Social Media",
      width: "92px"
    },
    {
      text:'Link',
      width: "360px"
    }
  ];
  const rowsSocial = [];

  if (data && Object.keys(data).length > 0 && data.index !== -1) {
    rowsSocial.push(['facebook', data.facebook], ['twitter', data.twitter], ['linkedin', data.linkedin], ['instagram', data.instagram], ['pinterest', data.pinterest]);
  }

  return (
    <>
      {isLoading ? (
        <CmsCircularProgress />
      ) : (
        <ContentWrapper>
          <Title>Footer details</Title>
          <CustomTable columns={columns} rows={rows} />       
          <br />

          <div className="SocialMedia">
            <h5>Social Media</h5>

            <CustomTable columns={columnsSocial} rows={rowsSocial} />   
          </div>

          <Link
            to={`/${partnerId}/footer/update/${data?.id ? data.id : "create"}`}
          >
            <Button className="FooterEdit" variant="primary" type="submit">
              Edit details
            </Button>
          </Link>
        </ContentWrapper>
      )}
    </>
  );
}

const Title = styled.h2`
  text-align: center;
`;

const ContentWrapper = styled.div`
    @media (min-width:576px) {
    padding: 1rem;
    }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;